import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed, getDefaultThemedOptions } from '@indeed/ifl-css';
import { FORM_SIZES } from '../../constants/index.js';
import transition from '../../utils/transition.js';
import createResponsive from '../../utils/createResponsive.js';
import useId from '@indeed/ihl-use-id';
import { jsx } from '@emotion/react';
import { Label } from '../Label/Label.js';
import { Flex } from '../Flex/Flex.js';
import { Box } from '../Box/Box.js';
import { Text } from '../Text/Text.js';
import '../../utils/styled.js';
import '../VisuallyHidden/VisuallyHidden.js';

const labelSizes = {
  sm: "3",
  md: "sc3"
};
const sizes = {
  sm: 1.25,
  md: 1.5
};
const getSize = createResponsive(size => `${sizes[size]}rem`);
const getLabelPaddingBlock = createResponsive(size => labelSizes[size]);
const getDotSize = createResponsive(size => `${sizes[size] / 2}rem`);
const RadioInput = /*#__PURE__*/themed("input", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "e1rw0n9c0"
}, getDefaultThemedOptions("inputSize", "invalid")) : _extends({}, {
  target: "e1rw0n9c0",
  label: "RadioInput"
}, getDefaultThemedOptions("inputSize", "invalid")))(_ref => {
  let {
    inputSize = "md",
    invalid
  } = _ref;
  return {
    appearance: "none",
    position: "relative",
    boxSizing: "border-box",
    inlineSize: getSize(inputSize),
    blockSize: getSize(inputSize),
    borderRadius: "full",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: invalid ? "border.status.critical.strong" : "border.action",
    bg: "background.action",
    cursor: "pointer",
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineStart: 0,
    marginInlineEnd: 0,
    flexShrink: 0,
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "background-color", "border-color", "box-shadow");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    "&:hover": {
      bg: "background.action.hover",
      borderColor: "border.action.hover"
    },
    "&:active": {
      bg: "background.action.active",
      borderColor: "border.action.active"
    },
    "&:focus-visible": {
      outline: 0,
      boxShadow: "focus"
    },
    "&:after": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "50%",
      inlineSize: getDotSize(inputSize),
      blockSize: getDotSize(inputSize),
      borderRadius: "full",
      bg: "transparent",
      transform: "translate(-50%, -50%)",
      transition: _ref3 => {
        let {
          transitions
        } = _ref3;
        return `background-color ${transitions.default}`;
      },
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
      }
    },
    // Selected
    "&:checked:after": {
      bg: "background.inverse"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/radio
 */
const Radio = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    as = "label",
    className,
    children,
    disabled,
    id,
    invalid,
    label,
    description,
    size = "md",
    sx,
    ...props
  } = _ref4;
  const radioId = useId(id);
  const descriptionId = description ? `radio-description-${radioId}` : undefined;
  const ariaDescribedBy = [descriptionId, props["aria-describedby"]].filter(value => value !== undefined).filter(Boolean).join(" ") || undefined;
  return jsx(Label, {
    as: as,
    htmlFor: radioId,
    disabled: disabled,
    size: size,
    className: className,
    sx: {
      display: "flex",
      fontWeight: "normal",
      position: "relative",
      paddingBlockStart: getLabelPaddingBlock(size),
      paddingBlockEnd: getLabelPaddingBlock(size),
      cursor: "pointer",
      ...sx
    }
  }, jsx(RadioInput, _extends({
    id: radioId,
    ref: ref,
    type: "radio",
    inputSize: size,
    disabled: disabled,
    invalid: invalid,
    "aria-invalid": invalid
  }, props, {
    "aria-describedby": ariaDescribedBy
  })), children || label ? jsx(Flex, {
    as: "span",
    sx: {
      flexDirection: "column"
    }
  }, jsx(Box, {
    as: "span",
    sx: {
      flexGrow: 1,
      marginInlineStart: 3,
      display: "block"
    }
  }, children || label), description && jsx(Text, {
    level: 2,
    "aria-hidden": true,
    id: descriptionId,
    sx: [{
      color: "foreground",
      marginInlineStart: 3,
      transition: _ref5 => {
        let {
          transitions
        } = _ref5;
        return `opacity ${transitions.default}`;
      }
    }, disabled ? {
      opacity: 0.4
    } : {}]
  }, description)) : null);
});
const RADIO_SIZES = FORM_SIZES;
Radio.displayName = "Radio";

export { RADIO_SIZES, Radio };
